/*********************************************************************************************
* Splide product
	*
*/

document.addEventListener('DOMContentLoaded', function() {

    var routineSections = document.querySelectorAll('[data-section-testimonials-id]');

    routineSections.forEach(function(section) {
        var id = '.mm-testimonials-splide';
        var splideElem = document.querySelector(id);
        var scrollCounter = 0;

        // Crée une instance Splide et la monte
        var splideInstance = new Splide(splideElem, {
            type        : 'loop',
            arrows      : true,
            pagination  : true,
            gap         : '40px',
            fixedWidth  : '310px',
            drag        : 'free',
            snap        : true,	
            start       : 0,
            perMove     : 1,
            focus       : 'center',
        }).mount();

        // Ajoute l'écouteur d'événement de défilement à splideElem
        splideElem.addEventListener('wheel', function(e) {
            // Ne pas empêcher le comportement par défaut si le défilement est vertical
            if (Math.abs(e.deltaY) > Math.abs(e.deltaX)) {
                return;
            }

            // Empêche le comportement par défaut uniquement pour le défilement horizontal
            e.preventDefault();

            // Incrémente le compteur de défilements
            scrollCounter++;

            // Vérifie si le compteur atteint le seuil pour un mouvement
            if (scrollCounter >= 12) {
                // Réinitialise le compteur
                scrollCounter = 0;

                // Déplace la diapositive selon la direction du défilement horizontal
                if (e.deltaX < 0) {
                    splideInstance.go('<'); // Mouvement vers la gauche
                } else if (e.deltaX > 0) {
                    splideInstance.go('>'); // Mouvement vers la droite
                }
            }
        });
    });
});
